function setSidebarHeight() {
	let sidebar = $('.panel--sidebar .js-contents > .contents-nav');
	if ($(window).width() > 960) {
		let currentItem = $('.contents-nav__item._current a');
		if (currentItem.length) {
			if ((currentItem.position().top + 50) > sidebar.innerHeight()) {
				sidebar.stop().animate({
					scrollTop: currentItem.position().top - sidebar.innerHeight() + sidebar.scrollTop() + 80
				}, 300);
			}
			if (currentItem.position().top <= 80) {
				sidebar.stop().animate({
					scrollTop: currentItem.position().top + sidebar.scrollTop() - 50
				}, 300);
			}
		}
		// if ($(window).scrollTop() >= sidebar.offset().top) {
		// 	sidebar.css('height', '100vh')
		// } else {
		// 	sidebar.css('height', $(window).height() - sidebar.offset().top + $(window).scrollTop() + 'px')
		// }
	}
}

$(document).ready(function () {
	setSidebarHeight();
});
$(window).scroll(function () {
	setSidebarHeight()
})